import React, { FC } from 'react';
import classNames from 'classnames';

export interface Props {
    className?: string;
    children: React.ReactNode;
}

export const OrderPartsHelpContents: FC<Props> = ({ className, children }) => (
    <div className={classNames('order-parts-help-contents', className)}>
        {children}
    </div>
);

export const Paragraph: FC<Props> = ({ className, children }) => (
    <p className={classNames('paragraph', className)}>{children}</p>
);

export const Title: FC<Props> = ({ className, children }) => (
    <h2 className={classNames('title', className)}>{children}</h2>
);

export const SubTitle: FC<Props> = ({ className, children }) => (
    <h3 className={classNames('subtitle', className)}>{children}</h3>
);

export const SubHeading: FC<Props> = ({ className, children }) => (
    <h4 className={classNames('subheading', className)}>{children}</h4>
);

export const Image: FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
    className,
    ...args
}) => <img className={classNames('image', className)} alt="img" {...args} />;
